import React, { useEffect, useMemo, useRef, useState } from "react";
import ImageLinks from "../../../assets/Images/ImagesLink";
import { useNavigate, useSearchParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import api_requests from "../../../resources/api_requests";
import moment from "moment";
import _ from "lodash";
import TxnTypeModal from "../../../modules/modals/TxnTypeModal";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { hide_loader, show_loader } from "../../../actions/app";
import {
  AddIcon,
  ArrowRightCircle,
  Calendar,
  ChevronDownBlue,
} from "../../../assets/whiteLabelIcon";
import Footer from "../../../Footer";
import {
  convertUTCToTimezone,
  formatCurrencyCountry,
} from "../../../resources/internationalizationUtils";
import { useTranslation } from "react-i18next";

const transaction_type_filter = [
  { title: "All", value: "all" },
  { title: "Credit", value: "credit" },
  { title: "Debit", value: "debit" },
];
const WalletList = () => {
  const { is_loading } = useSelector((state) => state.app, shallowEqual);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [show_status_modal, set_show_status_modal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const date = searchParams.get("date");
  const [show_type_modal, set_show_type_modal] = useState(false);
  const [selected_month, set_selected_month] = useState(
    date ? new Date(date) : new Date(),
  );
  const [history_data, set_history_data] = useState([]);
  const [business_details, set_business_details] = useState(null);
  const [type_filter, set_type_filter] = useState(transaction_type_filter[0]);
  const original_list = useRef([]);
  const [is_calendar_open, set_is_calendar_open] = useState(false);
  const [show_transaction_modal, set_show_transaction_modal] = useState(false);

  const userDetails = useSelector((state) => state.app.user_details);
  const currency_code = userDetails?.currency || "DEFAULT";
  const tz = userDetails?.business_timezone || "DEFAULT";
  const { t } = useTranslation();

  const formattedBalance = formatCurrencyCountry(
    business_details?.balance,
    currency_code,
  )?.formatedAmount;

  useEffect(() => {
    get_history_data();
    get_business_details();
  }, []);

  useEffect(() => {
    setSearchParams({ date: selected_month.toISOString() }, { replace: true });
  }, [selected_month]);

  const get_history_data = async (filtered_data = null) => {
    const date = moment(filtered_data || selected_month).format("YYYY-MM-DD");
    try {
      dispatch(show_loader());
      const response = await api_requests.get_day_wise_txn_history(date);
      if (response.success) {
        original_list.current = response.data.records;
        set_history_data(response.data.records);
        dispatch(hide_loader());
      }
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const get_business_details = async () => {
    try {
      dispatch(show_loader());
      const response = await api_requests.get_business_details();
      if (response.success) {
        set_business_details(response.data);
        dispatch(hide_loader());
      }
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const on_date_change = (val) => {
    get_history_data(val);
    set_selected_month(val);
  };

  const on_select_filter = (val) => {
    set_type_filter(val);
    if (val?.value === "all") set_history_data(original_list.current);
    if (val?.value === "debit")
      set_history_data(
        _.filter(
          original_list.current,
          (item) => item.transaction_type === 200,
        ),
      );
    if (val?.value === "credit")
      set_history_data(
        _.filter(
          original_list.current,
          (item) => item.transaction_type === 100,
        ),
      );
  };

  const toggleCalendar = (e) => {
    e.stopPropagation();
    set_is_calendar_open((prev) => !prev);
  };

  const handleDateChange = (date) => {
    on_date_change(date);
    set_is_calendar_open(false);
  };

  const total_spends = useMemo(() => {
    let total_amount = 0;
    if (!_.isEmpty(history_data)) {
      total_amount = history_data
        .filter((transaction) => transaction.transaction_type === 200)
        .reduce((sum, transaction) => sum + transaction.amount, 0);
    }
    return formatCurrencyCountry(total_amount, currency_code)?.formatedAmount;
  }, [history_data]);
  return (
    <>
      <div className="min-h-screen py-5 overflow-hidden h-[100vh]">
        {!show_transaction_modal && (
          <header
            className="flex items-center mb-6 px-6"
            onClick={() => navigate(-1)}
          >
            <img src={ImageLinks.chevron_left} />
            <button className="font-custom text-sm font-semibold ml-2">
              {t("wallet")}
            </button>
          </header>
        )}

        <div
          className="mx-6 mt-8 h-[158px] rounded-xl p-4 flex flex-col justify-between bg-custom_gradient bg-custom-gradient from-secondary to-primary"
          style={{
            boxShadow: `0px 0px 8px 0px #A6A6A640`,
          }}
        >
          <div className="flex justify-between">
            <div>
              <p className="font-custom font-semibold text-xl text-white">
                <span className="text-3xl">{formattedBalance}</span>
              </p>
              <p className="font-custom font-bold text-xs text-gray">
                {t("available_bal")}
              </p>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="flex flex-col">
              <p className="font-custom font-bold text-sm text-white">
                {business_details?.brand_name}
              </p>
              <p className="font-custom text-xs text-white font-normal">
                {business_details?.business_name}
              </p>
            </div>
            <div
              className="rounded-[20px] bg-white flex items-center gap-2 justify-center px-[14px] py-[5px]"
              onClick={() => {
                navigate("/add-funds", {
                  state: { data: business_details },
                });
              }}
            >
              <AddIcon />
              {/* <img src={ImageLinks.add_purple} className="w-[10px] h-[10px]" /> */}
              <p className="font-custom text-[10px] text-primary font-normal">
                {t("add_funds")}
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center mt-6 px-6">
          <div className="flex ">
            <button
              className={`btn btn-outline border-secondary rounded-full btn-sm flex justify-between w-[130px]`}
              onClick={() => set_show_type_modal(true)}
            >
              <p
                className={`font-custom font-semibold text-secondary text-[10px]`}
              >
                {type_filter.title === "All"
                  ? t("transaction_type")
                  : t(type_filter.title.toLowerCase())}
              </p>
              <ChevronDownBlue />
            </button>
          </div>
          <div className="relative">
            <div className={"flex items-center"} onClick={toggleCalendar}>
              <Calendar />
              <p className="font-custom font-semibold text-xs text-secondary ml-1">{`${moment(
                selected_month,
              ).format("DD/MMM/YYYY")}`}</p>
            </div>
            {is_calendar_open && (
              <div className="absolute right-0 z-50 top-5">
                <DatePicker
                  selected={selected_month}
                  onChange={handleDateChange}
                  inline
                  maxDate={new Date()}
                />
              </div>
            )}
          </div>
        </div>
        <div className="bg-accents my-4">
          <div className="px-6 py-2 flex justify-between">
            <div className="flex flex-col gap-0.5">
              <p className="font-custom text-xs text-primary font-semibold">
                {moment(selected_month).format("YYYY")}
              </p>
              <p className="font-custom text-base text-dark_black font-semibold">
                {moment(selected_month).format("MMMM")}
              </p>
            </div>
            <div className="flex flex-col gap-0.5 justify-end items-end">
              <p className="font-custom text-xs text-primary font-semibold">
                {t("spends")}
              </p>
              <p className="font-custom text-base text-dark_black font-semibold">
                {total_spends}
              </p>
            </div>
          </div>
        </div>
        {!is_loading && _.isEmpty(history_data) ? (
          <div
            className="flex flex-col justify-center w-full p-10 items-center text-center"
            style={{
              height: `calc(100vh - 450px - env(safe-area-inset-bottom))`,
            }}
          >
            <p className="font-custom text-xs font-medium text-dark_gray">
              {"no_transaction"}
            </p>
          </div>
        ) : (
          <div
            className="mt-2 px-6 overflow-auto"
            style={{
              height: `calc(100vh - 432px - env(safe-area-inset-bottom))`,
              paddingBottom: 40,
            }}
          >
            {_.map(history_data, (txn_item, txn_index) => (
              <div
                key={`txn_item_${txn_index}`}
                onClick={() => {
                  // set_transaction_data(txn_item);
                  // set_show_transaction_modal(true);
                  navigate(
                    `/transaction-info?date=${encodeURIComponent(selected_month.toISOString())}`,
                    {
                      state: { data: txn_item },
                    },
                  );
                }}
                className="py-3 border-b-[1px] divide-solid border-light_gray flex justify-between items-center"
              >
                <div className="w-[72%]">
                  <p className="line-clamp-1 font-custom font-semibold text-xs">
                    {txn_item?.description}
                  </p>
                  <p className="text-[10px] text-gray font-custom font-semibold">
                    {convertUTCToTimezone(txn_item?.timestamp, tz, "DD MMMM")}
                    <span className="mx-2">|</span>
                    {convertUTCToTimezone(txn_item?.timestamp, tz, "hh:mmA")}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <p
                    className={`font-custom font-bold text-sm ${
                      txn_item.transaction_type === 200
                        ? "text-black"
                        : "text-dark_green"
                    }`}
                  >
                    <span className="mr-1">
                      {txn_item.transaction_type === 200 ? "-" : "+"}
                    </span>
                    {
                      formatCurrencyCountry(txn_item?.amount, currency_code)
                        ?.formatedAmount
                    }
                  </p>
                  <ArrowRightCircle />
                  {/* <img src={ImageLinks.arrow_right_circle_blue} /> */}
                </div>
              </div>
            ))}
          </div>
        )}
        {show_type_modal && (
          <TxnTypeModal
            value={type_filter}
            close={() => set_show_type_modal(false)}
            handle_change={on_select_filter}
          />
        )}
      </div>
      <Footer bottom={0} />
      {/* {show_transaction_modal && (
        <TransactionInfo
          data={transaction_data}
          close={() => set_show_transaction_modal(false)}
        />
      )} */}
    </>
  );
};

export default WalletList;
